
import Vue from 'vue';
import Component from 'vue-class-component';
import MenuButton from './MenuButton.vue';
import { Watch } from 'vue-property-decorator';
import UserModule from '@/store/modules/User';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import router from '@/router';
import Settings from './header/Settings.vue';
import ChatWindow from './header/ChatWindow.vue';
import ChatWidget from './header/ChatWidget.vue';
import UserPanel from './header/UserPanel.vue';
import UploadModule from '@/store/modules/Upload';
import SessionsModule from '@/store/modules/Sessions';
import VueTour from './VueTour.vue';

const userState = getModule(UserModule, store);
const uploadState = getModule(UploadModule, store);
const sessionsState = getModule(SessionsModule, store);

@Component({
    components: {
        MenuButton,
        Settings,
        ChatWindow,
        ChatWidget,
        UserPanel,
        VueTour,
    },
})

export default class Header extends Vue {
    
    private scrollY: number = 0;
    private originalBarPosition: number = 0;
    private scrollListener!: () => void;
    private barPlaceholder?: HTMLElement;
    private currentRoute = router.currentRoute;
    private isBarSticked: boolean = false;
    private isLeavingSessionNav = false;
    private isLeavingSessionListNav = false;
    private sessionLeaveListener: EventListener | null = null;
    private sessionListLeaveListener: EventListener | null = null;

    get user() {
        return userState.user;
    }

    get slotContainerClass(): string {
        return this.$vuetify.breakpoint.width < 800 ? 'sm' : 'md justify-center ';
    }

    public openStatusDrawer() {
        if (this.uploadCount > 0) {
            this.$emit('openDrawerTransfers');
        }
    }

    public emitUiRippleFromClick(event: MouseEvent) {
        window.dispatchEvent(new CustomEvent('raws-ui-ripple', {
            detail: {
                x: event.clientX,
                y: event.clientY,
            },
        }));
    }

    public onStuckMenuSessionsClick(event: MouseEvent) {
        this.emitUiRippleFromClick(event);
        this.$router.push('/sessions');
    }

    public mounted() {
        Vue.nextTick(() => {
            const bar = (this.$refs.menuBar as HTMLDivElement);
            this.scrollY = window.scrollY;
            this.originalBarPosition = bar.offsetTop;
            this.barPlaceholder = document.createElement('div');
            this.barPlaceholder.style.width = `100%`;
            this.barPlaceholder.style.height = `${bar.offsetHeight}px`;
        });

        this.scrollListener = () => {
            this.scrollY = window.scrollY;
        };

        window.addEventListener('scroll', this.scrollListener);

        this.sessionLeaveListener = () => {
            this.isLeavingSessionNav = true;
            window.setTimeout(() => { this.isLeavingSessionNav = false; }, 340);
        };
        window.addEventListener('raws-session-leave', this.sessionLeaveListener);

        this.sessionListLeaveListener = () => {
            this.isLeavingSessionListNav = true;
            window.setTimeout(() => { this.isLeavingSessionListNav = false; }, 340);
        };
        window.addEventListener('raws-sessionlist-leave', this.sessionListLeaveListener);
    }

    public beforeDestroy() {
        window.removeEventListener('scroll', this.scrollListener);
        if (this.sessionLeaveListener) {
            window.removeEventListener('raws-session-leave', this.sessionLeaveListener);
            this.sessionLeaveListener = null;
        }
        if (this.sessionListLeaveListener) {
            window.removeEventListener('raws-sessionlist-leave', this.sessionListLeaveListener);
            this.sessionListLeaveListener = null;
        }
    }

    @Watch('scrollY')
    public onScroll() {
        const el: HTMLElement = this.$refs.menuBar as HTMLElement;

        if (
            !el.classList.contains('barSticked') &&
            this.scrollY > this.originalBarPosition
        ) {
            el.classList.add('barSticked');
            const barHeight = el.offsetHeight;
            this.barPlaceholder!.style.height = `${barHeight}px`;
            el.parentNode!.insertBefore(this.barPlaceholder!, el);
            this.isBarSticked = true;
        } else if (
            el.classList.contains('barSticked') &&
            this.scrollY < this.originalBarPosition
        ) {
            this.barPlaceholder!.parentNode!.removeChild(this.barPlaceholder!);
            el.classList.remove('barSticked');
            this.isBarSticked = false;
        }
    }

    get uploadCount() {
        return uploadState.uploadList.length;
    }

    get hasUploadErrors() {
        return uploadState.hasUploadErrors;
    }

    get finishedCount() {
        return uploadState.uploadList.filter((item) => item.status === 'finished').length;
    }

    get isInsideFolder() {
        return sessionsState.folderState.isInsideFolder;
    }

    get currentFolder() {
        return sessionsState.currentFolder;
    }

    get hasAnySessions() {
        const user = userState.user;
        if (!user) {
            return false;
        }
        const list = sessionsState.sessionList[user.id] || [];
        return list.length > 0;
    }

    get hasSessionsOutsideFolders() {
        const user = userState.user;
        if (!user) {
            return false;
        }
        const list = sessionsState.sessionsNotInFolders[user.id] || [];
        return list.length > 0;
    }

    public exitFolder(event?: MouseEvent) {
        if (event) {
            window.dispatchEvent(new CustomEvent('raws-ui-ripple', {
                detail: {
                    x: event.clientX,
                    y: event.clientY,
                },
            }));
        }

        window.dispatchEvent(new CustomEvent('raws-folder-exit'));
    }

    public editCurrentFolder() {
        this.$emit('openEditFolderModal');
    }

    public openNewFolderModal() {
        this.$emit('openNewFolderModal');
    }
}
